import { render, staticRenderFns } from "./BranchQuestions.vue?vue&type=template&id=1234772a&"
import script from "./BranchQuestions.vue?vue&type=script&lang=js&"
export * from "./BranchQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports